// Scheduler flags
export const WEB_MARKETING_US_TRIAL_FLAG = 'web:marketing-us-trial-flag'
export const WEB_MARKETING_LATINO_TRIAL_FLAG = 'web:marketing-latino-trial-flag'
export const WEB_MARKETING_CANADA_TRIAL_FLAG = 'web:marketing-canada-trial-flag'
export const WEB_MARKETING_PPV_UEFA_WCQ = 'web:marketing-uefa-wcq-scheduler'
export const WEB_MARKETING_INTERNATIONAL_FRIENDLY_SCHEDULER =
  'web:marketing-international-friendly-scheduler'
export const WEB_MARKETING_PPV_INTEGRATED_SPORTS = 'web:marketing-ppv-integrated-sports'

// A/B Tests
export const WEB_MARKETING_ADCASH_CTA_URL = 'web:marketing-adcash-cta-url'
export const WEB_MARKETING_LIVE_PREVIEW_DURATION = 'web:marketing-live-preview-duration'
export const WEB_MARKETING_CA_VALUE_PROPS = 'web:marketing-ca-value-props'
export const WEB_MARKETING_NBA_COUNTDOWN_TIMER = 'web:marketing-nba-countdown-timer-v2'
export const WEB_MARKETING_NHL_COUNTDOWN_TIMER = 'web:marketing-nhl-countdown-timer-v2'
export const WEB_MARKETING_HERO_IMAGE = 'web:marketing-hero-network-logos'
export const WEB_MARKETING_HEADER_SIGN_IN = 'web:marketing-header-sign-in'
